import React, { useState, useContext } from "react";
import axios from "../../helper/axios";
import { useNavigate } from "react-router-dom"; // Assuming you are using React Router for routing
import { AuthContext } from "../../context/AuthContext";
import "./RegistrationAndLoginForm.css";

function RegistrationAndLoginForm() {
  const navigate = useNavigate();
  const {
    updateToken,
    updateUserName,
    updateUserType,
    updateUserId,
    updateEmailId,
    updatePhoneno,
    updateContactdetails,
    updateBillingAddress,
    updateShippingAddress,
  } = useContext(AuthContext);

  const [registerUser, setRegisterUser] = useState({
    user_name: "",
    user_email: "",
    user_password: "",
    user_type: "customer",
  });

  const [loginUser, setLoginUser] = useState({
    user_email: "",
    user_password: "",
  });

  const handleRegisterChange = (event) => {
    const { name, value } = event.target;
    setRegisterUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handleLoginChange = (event) => {
    const { name, value } = event.target;
    setLoginUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handleRegistrationSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post("/maitri_register", registerUser);
      navigate("/login");
      alert("Registered Sucessfully"); // Handle success response
    } catch (error) {
      console.error(error); // Handle error response
    }
  };

  const handleLoginSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post("/maitri_login", loginUser);
      const { token, user_name, user_type, user_id, email_id } = response.data;

      updateToken(token);
      updateUserName(user_name);
      updateUserType(user_type);
      updateUserId(user_id);
      updateEmailId(email_id);

      if (user_type == "customer") {
        navigate("/");
      }
      if (user_type == "admin") {
        navigate("/dashboard");
      }
    } catch (error) {
      console.error(error);
      alert("Username or password is incorrect!");
    }
  };

  return (
    <>
      <section className="regiloginform-section mt-5">
        <div className="container">
          <div className="regiloginform-row">
            <div className="form-block">
              <h2 className="form-heading">User Registration</h2>
              <form onSubmit={handleRegistrationSubmit}>
                <div className="form-field">
                  <label htmlFor="user_name">Username:</label>
                  <input
                    type="text"
                    id="regi_user_name"
                    name="user_name"
                    value={registerUser.user_name}
                    onChange={handleRegisterChange}
                    required
                  />
                </div>

                <div className="form-field">
                  <label htmlFor="user_email">Email:</label>
                  <input
                    type="email"
                    id="regi_user_email"
                    name="user_email"
                    value={registerUser.user_email}
                    onChange={handleRegisterChange}
                    required
                  />
                </div>

                <div className="form-field">
                  <label htmlFor="user_password">Password:</label>
                  <input
                    type="password"
                    id="regi_user_password"
                    name="user_password"
                    value={registerUser.user_password}
                    onChange={handleRegisterChange}
                    required
                  />
                </div>

                <div className="form-field d-none">
                  <label htmlFor="user_type">User Type:</label>
                  <input
                    type="text"
                    id="regi_user_type"
                    name="user_type"
                    value={registerUser.user_type}
                    onChange={handleRegisterChange}
                  />
                </div>

                <button type="submit" className="btn btn__primary pt-2">
                  Register
                </button>
              </form>
            </div>
            <div className="form-block">
              <h2 className="form-heading">Login</h2>
              <form onSubmit={handleLoginSubmit}>
                <div className="form-field">
                  <label htmlFor="user_email">Email:</label>
                  <input
                    type="email"
                    id="user_email"
                    name="user_email"
                    value={loginUser.user_email}
                    onChange={handleLoginChange}
                    required
                  />
                </div>

                <div className="form-field">
                  <label htmlFor="user_password">Password:</label>
                  <input
                    type="password"
                    id="user_password"
                    name="user_password"
                    value={loginUser.user_password}
                    onChange={handleLoginChange}
                    required
                  />
                </div>

                <button type="submit" className="btn btn__primary pt-2">
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default RegistrationAndLoginForm;
